import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <circle cx="19.692" cy="19.692" r="19.692" fill={fill} />
                <g stroke={stroke} strokeLinecap="square" strokeWidth="1.64" transform="translate(10 12)">
                    <line x2="20.119" y1="3.658" y2="3.658" />
                    <line x2="20.119" y1="8.23" y2="8.23" />
                    <path d="M20.11856,8.23032 L20.11856,1.82896 C20.11856,0.823032 19.295528,0 18.2896,0 L13.7172,0 L1.82896,0 C0.823032,0 0,0.823032 0,1.82896 L0,13.7172 C0,14.723128 0.823032,15.54616 1.82896,15.54616 L7.31584,15.54616" />
                    <polygon points="13.717 20.119 10.974 20.119 10.974 17.375 16.461 11.888 19.204 14.632" />
                </g>
            </g>
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <g fill="none" fillRule="evenodd" stroke={stroke} strokeLinecap="square" transform="translate(1 1)">
                <line x2="14.168" y1="2.576" y2="2.576" />
                <line x2="14.168" y1="5.796" y2="5.796" />
                <path d="M14.168,5.796 L14.168,1.288 C14.168,0.5796 13.5884,0 12.88,0 L9.66,0 L1.288,0 C0.5796,0 0,0.5796 0,1.288 L0,9.66 C0,10.3684 0.5796,10.948 1.288,10.948 L5.152,10.948" />
                <polygon points="9.66 14.168 7.728 14.168 7.728 12.236 11.592 8.372 13.524 10.304" />
            </g>
        </svg>
    );
};

const MenuBillingEdit = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuBillingEdit.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuBillingEdit;
